import { FC } from "react";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { he } from "date-fns/locale";
import { useTranslation } from "react-i18next";

type TimePickerProps = {
  field: any;
  form: any;
  helperText?: string;
  error?: string;
};

const TimePicker: FC<TimePickerProps> = ({
  field,
  form,
  helperText,
  error,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={he}
      localeText={{
        timePickerToolbarTitle: t("SELECT_TIME"),
      }}
    >
      <MuiTimePicker
        helperText={error || helperText}
        sx={{ width: "100%" }}
        size="small"
        variant="outlined"
        error={error}
        {...field}
        value={new Date(field.value)}
        onChange={(val) => form.setFieldValue(field.name, val?.toISOString())}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;
